import React from 'react'

import { useAppDispatch, useAppSelector } from '@/client/hooks'
import { DELETED_FOLDER } from '@/features/FileManager/FileManager'
import {
  FileManagerFile,
  MODALS,
  selectFiles,
  setActiveModal,
} from '@/features/FileManager/fileManagerSlice'
import { downloadFile } from '@/features/FileManager/utilities'
import { useCurrentApplication } from '@/graphql/services/application'
import { useGetLoggedUserQuery } from '@/services/user'
import {
  isSalesUserAndAppNotInPendingICSDelivery,
  isUserAllowedToSendToDocuSign,
} from '@/utils/user'

export const FilesDotsMenu = ({ file }: { file: FileManagerFile }) => {
  const dispatch = useAppDispatch()
  const { selectedFiles, isICSDocGenerated } = useAppSelector((state) => state.fileManager)
  const { data: application } = useCurrentApplication()
  const { data: user } = useGetLoggedUserQuery()

  const _isSalesUserAndAppNotInPendingICSDelivery = isSalesUserAndAppNotInPendingICSDelivery({
    userGroups: user?.groups,
    applicationStateIndex: application?.applicationStateIndex,
  })

  const isSendToDocuSignEnabled = isUserAllowedToSendToDocuSign(user)

  const contextMenuItems = [
    {
      label: 'Open in Browser',
      onClick: () => selectedFiles.forEach((f) => window.open(f.filePath, '_blank')),
    },
    {
      label: 'Download',
      disabled: _isSalesUserAndAppNotInPendingICSDelivery && isICSDocGenerated,
      onClick: () => {
        if (_isSalesUserAndAppNotInPendingICSDelivery && isICSDocGenerated) return
        downloadFile(file)
      },
    },
    {
      label: 'Rename',
      onClick: () => dispatch(setActiveModal({ ...MODALS.RenameV2, file })),
    },
    {
      label: 'Move To',
      onClick: () => dispatch(setActiveModal({ ...MODALS.Move, file })),
    },
    {
      label: 'Send To Docusign',
      disabled:
        !isSendToDocuSignEnabled ||
        (_isSalesUserAndAppNotInPendingICSDelivery && isICSDocGenerated),
      onClick: () => {
        if (
          !isSendToDocuSignEnabled ||
          (_isSalesUserAndAppNotInPendingICSDelivery && isICSDocGenerated)
        )
          return
        dispatch(selectFiles([file]))
        dispatch(setActiveModal({ ...MODALS.DocusignV2, file }))
      },
    },
    {
      label: file.tag === DELETED_FOLDER ? 'Delete Permanently' : 'Delete',
      onClick: () => dispatch(setActiveModal({ ...MODALS.Delete, file })),
    },
  ]

  return (
    <ul className='menu bg-base-100 w-max border rounded-xl shadow-lg text-sky-800'>
      {contextMenuItems.map(({ label, onClick, disabled }, i) => (
        <li
          key={i}
          className={disabled ? 'disabled' : ''}
        >
          <a onClick={onClick}>{label}</a>
        </li>
      ))}
    </ul>
  )
}
